// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * PartiVotes Critical Overrides
 * 
 * This file contains the highest-priority overrides that MUST be applied regardless of theme.
 * These styles ensure consistent layout and behavior across the application.
 * 
 * IMPORTANT: This file should be imported LAST to ensure its styles take precedence.
 */

/* ===== Z-INDEX SYSTEM ===== */

/* Starfield - Always behind all content */
#space-travel-effect {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: var(--z-index-starfield) !important;
  pointer-events: none !important;
  background-color: var(--color-black) !important;
}

/* Fixed Header - Always at top, above content */
.app-header.MuiAppBar-root {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  z-index: var(--z-index-header) !important;
}

/* Fixed Footer - Always at bottom, above content */
.app-footer.MuiBox-root[component="footer"] {
  position: fixed !important;
  bottom: 0 !important;
  left: 0 !important;
  width: 100% !important;
  z-index: var(--z-index-footer) !important;
}

/* Main content - Scrolls under fixed elements */
.MuiContainer-root[component="main"] {
  position: relative !important;
  z-index: var(--z-index-content) !important;
}

/* ===== TITLE ANIMATIONS ===== */

/* PARTIVOTES-3000 Title */
.futuristic-theme .app-header .MuiTypography-root.cyberpunk-title,
.futuristic-theme .app-header .MuiTypography-root.cyberpunk-title a,
.app-header .MuiTypography-root.cyberpunk-title[component="a"] {
  animation: cyberpunk-color-cycle 3s infinite linear, 
             title-pulsate 3s infinite ease-in-out !important;
  color: var(--cyberpunk-cyan) !important; /* Initial color to prevent white flash */
  text-shadow: 0 0 15px var(--cyberpunk-cyan) !important;
  font-family: "Orbitron", sans-serif !important;
  font-weight: bold !important;
  letter-spacing: 1px !important;
  /* Force animation to work */
  animation-play-state: running !important;
  will-change: color, text-shadow, transform, letter-spacing !important;
}

/* Icon animation */
.futuristic-theme .app-header .MuiSvgIcon-root {
  animation: icon-pulse 4s infinite ease, 
             icon-color-cycle 3s infinite linear !important;
  color: var(--cyberpunk-cyan) !important; /* Initial color to prevent white flash */
  filter: drop-shadow(0 0 3px var(--cyberpunk-cyan)) !important;
  /* Force animation to work */
  animation-play-state: running !important;
  will-change: color, filter, transform, opacity !important;
}

/* ===== THEME FIXES ===== */

/* Ensure transparent backgrounds in futuristic theme */
html.futuristic-theme,
body.futuristic-theme,
#root.futuristic-theme {
  background: transparent !important;
}

/* Fix for any potential overflow issues */
html, body {
  overflow-x: hidden !important;
}

/* ===== RESPONSIVE FIXES ===== */

/* Mobile adjustments */
@media (max-width: 600px) {
  .app-header .MuiToolbar-root {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  
  .MuiContainer-root[component="main"] {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/critical-overrides.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,+BAA+B;;AAE/B,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,4CAA4C;EAC5C,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA,gDAAgD;AAChD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA,gDAAgD;AAChD;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA,iCAAiC;;AAEjC,0BAA0B;AAC1B;;;EAGE;6DAC2D;EAC3D,uCAAuC,EAAE,yCAAyC;EAClF,sDAAsD;EACtD,8CAA8C;EAC9C,4BAA4B;EAC5B,8BAA8B;EAC9B,4BAA4B;EAC5B,wCAAwC;EACxC,qEAAqE;AACvE;;AAEA,mBAAmB;AACnB;EACE;2DACyD;EACzD,uCAAuC,EAAE,yCAAyC;EAClF,6DAA6D;EAC7D,4BAA4B;EAC5B,wCAAwC;EACxC,yDAAyD;AAC3D;;AAEA,4BAA4B;;AAE5B,uDAAuD;AACvD;;;EAGE,kCAAkC;AACpC;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;AAC/B;;AAEA,iCAAiC;;AAEjC,uBAAuB;AACvB;EACE;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF","sourcesContent":["/**\n * PartiVotes Critical Overrides\n * \n * This file contains the highest-priority overrides that MUST be applied regardless of theme.\n * These styles ensure consistent layout and behavior across the application.\n * \n * IMPORTANT: This file should be imported LAST to ensure its styles take precedence.\n */\n\n/* ===== Z-INDEX SYSTEM ===== */\n\n/* Starfield - Always behind all content */\n#space-travel-effect {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  z-index: var(--z-index-starfield) !important;\n  pointer-events: none !important;\n  background-color: var(--color-black) !important;\n}\n\n/* Fixed Header - Always at top, above content */\n.app-header.MuiAppBar-root {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  z-index: var(--z-index-header) !important;\n}\n\n/* Fixed Footer - Always at bottom, above content */\n.app-footer.MuiBox-root[component=\"footer\"] {\n  position: fixed !important;\n  bottom: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  z-index: var(--z-index-footer) !important;\n}\n\n/* Main content - Scrolls under fixed elements */\n.MuiContainer-root[component=\"main\"] {\n  position: relative !important;\n  z-index: var(--z-index-content) !important;\n}\n\n/* ===== TITLE ANIMATIONS ===== */\n\n/* PARTIVOTES-3000 Title */\n.futuristic-theme .app-header .MuiTypography-root.cyberpunk-title,\n.futuristic-theme .app-header .MuiTypography-root.cyberpunk-title a,\n.app-header .MuiTypography-root.cyberpunk-title[component=\"a\"] {\n  animation: cyberpunk-color-cycle 3s infinite linear, \n             title-pulsate 3s infinite ease-in-out !important;\n  color: var(--cyberpunk-cyan) !important; /* Initial color to prevent white flash */\n  text-shadow: 0 0 15px var(--cyberpunk-cyan) !important;\n  font-family: \"Orbitron\", sans-serif !important;\n  font-weight: bold !important;\n  letter-spacing: 1px !important;\n  /* Force animation to work */\n  animation-play-state: running !important;\n  will-change: color, text-shadow, transform, letter-spacing !important;\n}\n\n/* Icon animation */\n.futuristic-theme .app-header .MuiSvgIcon-root {\n  animation: icon-pulse 4s infinite ease, \n             icon-color-cycle 3s infinite linear !important;\n  color: var(--cyberpunk-cyan) !important; /* Initial color to prevent white flash */\n  filter: drop-shadow(0 0 3px var(--cyberpunk-cyan)) !important;\n  /* Force animation to work */\n  animation-play-state: running !important;\n  will-change: color, filter, transform, opacity !important;\n}\n\n/* ===== THEME FIXES ===== */\n\n/* Ensure transparent backgrounds in futuristic theme */\nhtml.futuristic-theme,\nbody.futuristic-theme,\n#root.futuristic-theme {\n  background: transparent !important;\n}\n\n/* Fix for any potential overflow issues */\nhtml, body {\n  overflow-x: hidden !important;\n}\n\n/* ===== RESPONSIVE FIXES ===== */\n\n/* Mobile adjustments */\n@media (max-width: 600px) {\n  .app-header .MuiToolbar-root {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n  \n  .MuiContainer-root[component=\"main\"] {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
